  (function () {
    var f = document.querySelector('[data-snkl-footer]');
    if (!f) return;
    var wm = f.querySelector('[data-snkl-wordmark]');
    var logo = wm && wm.querySelector('img');
    var pay = f.querySelector('.snkl-footer__pay');
    var legal = f.querySelector('.snkl-footer__legal');
    if (!wm || !logo) return;
    // 🚨 Proporcja NIE jest juz zaszyta. Wczesniej byla stala `ASPECT` i kazda podmiana
    // assetu po cichu rozjezdzala geometrie (maxWM liczylo sie ze starej proporcji,
    // a realna wysokosc renderu z nowej => bialy pas albo obciety znak). Teraz mierzymy
    // RZECZYWISTA wysokosc renderu obrazu, wiec mechanizm sam sie dostraja.
    // To jest wymog, nie kosmetyka: od 2026-07-31 sa DWA znaki o roznych proporcjach
    // (mobile wordmark 3.529, desktop lockup 7.75) przelaczane przez <picture>.
    // ASPECT_ZAPAS uzywany TYLKO gdy pomiar wyjdzie zerowy (obraz bez atrybutow
    // width/height i przed zaladowaniem) - wtedy lepszy przyblizony niz zerowy.
    var ASPECT_ZAPAS = 340 / 1200;
    // reduced-motion => zostaw fw=1 (pelne odsloniecie), zero ruchu
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    /* ══════════════════════════════════════════════════════════════════════════
       🚨 AKORDEON POLITYK DOJEZDZA DO WIDOKU (2026-08-06, zgloszenie usera:
       „rozwija sie wydluzajac strone, a dla usera to jest koniec strony").

       Akordeon stoi jako OSTATNI element dokumentu, wiec jego rozwiniecie zawsze
       wypycha tresc pod krawedz ekranu - klikasz i nie widzisz efektu, tylko
       rosnacy pasek przewijania. Zwykla animacja wysokosci tego nie naprawi, bo
       problem nie jest w plynnosci, tylko w tym, ze odsloniete linki sa POZA kadrem.

       Po zakonczeniu rozwijania dosuwamy widok tak, zeby cala lista byla widoczna.
       `block: 'end'` zamiast 'start' - lista jest krotka, wiec przewijamy tylko
       tyle, ile trzeba, zamiast wyrzucac naglowek na gore ekranu.
       Zwijanie NIE przewija niczego: przegladarka sama przytnie scroll, a
       dodatkowy ruch przy chowaniu czytalby sie jak szarpniecie.
       ══════════════════════════════════════════════════════════════════════════ */
    (function () {
      var wejscie = document.querySelector('.snkl-footer__acc-input');
      var panel = document.querySelector('.snkl-footer__acc-panel');
      if (!wejscie || !panel) return;
      wejscie.addEventListener('change', function () {
        if (!wejscie.checked) return;
        var plynnie = !(window.matchMedia &&
          matchMedia('(prefers-reduced-motion: reduce)').matches);

        // 🚨 DOJAZD RUSZA RAZEM Z ROZWIJANIEM (poprawka 2026-08-06, zgloszenie:
        // „przejscie widoku powinno dziac sie w miare z animacja rozwijania").
        // Pierwsza wersja czekala na `transitionend` - przez to najpierw rosla
        // lista, a DOPIERO POTEM jechal widok. Dwa ruchy po kolei zamiast jednego.
        // Teraz liczymy cel Z GORY: `scrollHeight` dziecka zna pelna wysokosc
        // tresci nawet gdy panel jest scisniety do zera (przyciecie nie zmienia
        // wysokosci zawartosci), wiec wiemy o ile dokument urosnie, zanim urosnie.
        // Oba ruchy startuja w tej samej klatce i konca sie mniej wiecej razem.
        var tresc = panel.firstElementChild;
        var przyrost = tresc ? tresc.scrollHeight : 0;
        var docEl = document.documentElement;
        var vh = window.innerHeight || docEl.clientHeight;
        var cel = docEl.scrollHeight + przyrost - vh;

        // 🚨 WLASNE PRZEWIJANIE, NIE `behavior: smooth` (2026-08-06, zgloszenie:
        // „view nie zmienia sie plynnie zgodnie z animacja").
        // Natywny smooth-scroll ma czas trwania i krzywa narzucone PRZEZ
        // PRZEGLADARKE (~300-500ms, zaleznie od silnika i dystansu) - nie da sie
        // ich zsynchronizowac z naszym przejsciem siatki. Efekt: lista konczyla
        // rozwijanie w innym momencie niz widok konczyl jechac, wiec czytalo sie
        // to jako dwa ruchy. Tutaj przewijamy sami: TEN SAM czas (260ms) i TA SAMA
        // krzywa co `transition` w CSS, wiec oba ruchy sa jednym gestem.
        if (!plynnie) {
          window.scrollTo(0, cel);
        } else {
          var start = window.scrollY || window.pageYOffset || 0;
          var dystans = cel - start;
          if (Math.abs(dystans) > 1) {
            var CZAS = 260;
            var t0 = null;
            // cubic-bezier(0.4, 0, 0.2, 1) - ten sam co w CSS panelu
            var krzywa = function (x) {
              return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
            };
            var krok = function (ts) {
              if (t0 === null) t0 = ts;
              var p = Math.min(1, (ts - t0) / CZAS);
              window.scrollTo(0, start + dystans * krzywa(p));
              if (p < 1) requestAnimationFrame(krok);
            };
            requestAnimationFrame(krok);
          }
        }

        // 🚨 BEZ KOREKTY NA KONCU (usunieta 2026-08-06, zgloszenie: „dopiero po
        // zakonczeniu animacji widok poprawia sie na dol i robi sie to flashem").
        // Korekta wolala scrollIntoView BEZ animacji, wiec dawala przeskok - a do
        // tego odpalala sie, gdy plynne przewijanie jeszcze trwalo, przerywajac je
        // w polowie. Zabezpieczenie szkodzilo bardziej niz pomagalo.
        // Cel liczony wyzej z `scrollHeight` jest dokladny; ewentualna roznica
        // kilku pikseli jest niezauwazalna i nie warta drugiego ruchu.
      });
    })();

    var doc = document.documentElement;
    var clip = wm.querySelector('.snkl-footer__wm-clip') || wm;
    var p = -1, maxWM = 96, range = 300, lastW = -1;

    // 🚨 PLYNNOSC robi TRANZYCJA CSS na wysokosci klipu, nie interpolacja w JS.
    // Wczesniej dobijalem wartosc w requestAnimationFrame - dzialalo, ale uzalezenialo
    // caly efekt od tego, czy rAF w ogole tyka. Tranzycja daje ten sam efekt, jest
    // liczona przez przegladarke i nie ma dodatkowej czesci do zepsucia.
    // 🚨 p startuje z SENTINELA -1. Przy starcie z 0 pierwsze set(0) uznawaloby, ze nic
    // sie nie zmienilo, wychodziloby przed zapisem i --snkl-fw NIGDY nie byloby
    // ustawione - CSS zostawalby na fallbacku `1`, czyli cale logo zamiast polowy.
    function set(v) {
      v = v < 0 ? 0 : v > 1 ? 1 : v;
      if (p >= 0 && Math.abs(v - p) < 0.002) return;   // nie pisz na kazdy piksel
      p = v;
      f.style.setProperty('--snkl-fw', v.toFixed(3));
    }

    /* ══════════════════════════════════════════════════════════════════════════
       🚨 INTERPOLACJA KLATKA PO KLATCE - trzecie podejscie, po dwoch zgloszeniach
       „logo rozwija sie schodkami".

       DLACZEGO POPRZEDNIE NIE DZIALALY. Zdarzenia scrolla sa DYSKRETNE i rzadkie
       (co ~50-100ms). Model „skocz do nowej wartosci, a wygladzi tranzycja CSS"
       zawodzi, bo tranzycja 0.1s ZDAZY SIE ZAKONCZYC zanim przyjdzie kolejne
       zdarzenie - widac wiec osobne skoki, nie ciagly ruch. Wydluzanie tranzycji
       tego nie naprawia, tylko zamienia schodki na opoznienie (zgloszone wczesniej).

       MODEL DOCELOWY: zdarzenia ustawiaja wylacznie CEL. Osobna petla dogania go
       co KLATKE, wiec ruch jest ciagly niezaleznie od tego, jak rzadko sypia zdarzenia.
       Wygladzanie wykladnicze ze stala czasowa TAU, liczone z realnego dt - dzieki
       temu tempo jest takie samo przy 60 i przy 120 klatkach na sekunde.

       🚨 Tranzycja CSS jest teraz WYLACZONA na czas ruchu (patrz [data-snkl-pull]);
       nakladanie jej na interpolacje wygladzaloby dwa razy i wracaloby opoznienie.
       ══════════════════════════════════════════════════════════════════════════ */
    var cel = 0;            // dokad zmierzamy (ustawiaja zdarzenia)
    var biezacy = 0;        // co realnie widac (dogania cel)
    var TAU = 85;           // ms; mniej = szybsza reakcja, wiecej = bardziej leniwe
    var klatka = null, tKlatki = 0;
    // 🚨 Czy palec JEST na ekranie. Deklaracja tutaj (przed petla), bo `tY` nizej
    // jest hoistowane jako undefined i test w petli bylby nieprawdziwy w 1. klatce.
    var dotykAktywny = false;
    /* 🚨 PED PO PUSZCZENIU PALCA (2026-09-09, zgloszenie: „rozwijanie logo w stopce
       nie dziala plynnie na mobile, na Safari na iOS").
       Poprawka z 2026-08-05 wstrzymala dopinanie widoku TYLKO na czas, gdy palec
       dotyka ekranu (`dotykAktywny`). Na iOS to za malo: po `touchend` Safari prowadzi
       WLASNE przewijanie z pedem jeszcze kilkaset ms, a wtedy `dotykAktywny` jest juz
       `false`, wiec petla rAF wracala do wolania `przypnijDoDna()` co klatke. Kazde
       `window.scrollTo` w trakcie pedu PRZERYWA go i cofa widok - dokladnie to widac
       jako szarpanie tuz po zabraniu palca.
       Model: `pedDo` zapala sie na `touchend` i jest PRZEDLUZANY przez kolejne
       zdarzenia scrolla; gdy przez 140 ms nie przyjdzie zadne, ped uznajemy za
       zakonczony i dopinamy RAZ. Mysz nigdy nie ustawia tej flagi (nie ma `touchend`),
       wiec zachowanie na desktopie - to, ktore wlasciciel zaakceptowal - jest nietkniete. */
    var pedDo = 0;
    var dopinacz = null;
    function pedTrwa() { return pedDo !== 0 && Date.now() < pedDo; }
    function dopnijPoPedzie() {
      if (dopinacz) clearTimeout(dopinacz);
      dopinacz = setTimeout(function () {
        dopinacz = null;
        if (pedTrwa()) { dopnijPoPedzie(); return; }
        pedDo = 0;
        przypnijDoDna();
      }, 160);
    }

    function petla(ts) {
      if (!tKlatki) tKlatki = ts;
      var dt = ts - tKlatki;
      if (dt > 60) dt = 60;               // po przelaczeniu karty nie przeskakuj
      tKlatki = ts;

      var k = 1 - Math.exp(-dt / TAU);    // niezalezne od klatkazu
      biezacy += (cel - biezacy) * k;
      if (Math.abs(cel - biezacy) < 0.0015) biezacy = cel;
      set(biezacy);
      // 🚨 FIX 2026-08-04b (zgloszenie usera: "naciag nie jest plynny"): podczas
      // ciagniecia tranzycje sa wylaczone, wiec `transitionend` NIE strzela, a
      // dopiecie widoku do dna robilo sie tylko raz na ZDARZENIE wejsciowe (co
      // 50-100ms) - wzrost logo dzial sie poza ekranem i "doskakiwal" seriami.
      // 🚨 FIX 2026-08-04c (zgloszenie usera: "logo nie pozwala przescrollowac
      // do gory w trakcie chowania"): dopinamy WYLACZNIE w fazie WZROSTU
      // (biezacy < cel). Warunek na atrybucie data-snkl-pull lapal tez cala faze
      // POWROTU i scrollTo sciagalo usera na dno co klatke, walczac z jego
      // scrollem w gore. Zwijanie nie potrzebuje dopinania: strona sie skraca,
      // przegladarka sama przycina scrollY.
      // 🚨 FIX 2026-08-05 (user: "rozciaganie logo w stopce na mobile nie jest plynne"):
      // NIE dopinamy, dopoki palec jest na ekranie. Przy aktywnym gescie przegladarka
      // prowadzi wlasne przewijanie, a nasze scrollTo co klatke z nim walczylo -
      // tresc szarpala sie pod palcem. Gdy wordmark rosnie, dokument sam sie wydluza,
      // wiec natywny scroll plynnie wchodzi w nowo powstala przestrzen i dopinanie
      // jest tam zbedne. Po puszczeniu palca (touchend) dopinamy raz, na koniec.
      // Kolko myszy nie ma stanu "aktywny", wiec na desktopie zachowanie bez zmian.
      if (!dotykAktywny && !pedTrwa() && biezacy < cel - 0.001) przypnijDoDna();

      if (biezacy !== cel || cel > 0) {
        klatka = requestAnimationFrame(petla);
      } else {
        klatka = null; tKlatki = 0;
        wm.removeAttribute('data-snkl-pull');   // wrocil do spoczynku
      }
    }
    function ruszPetle() {
      if (!wm.hasAttribute('data-snkl-pull')) wm.setAttribute('data-snkl-pull', '');
      if (klatka === null) { tKlatki = 0; klatka = requestAnimationFrame(petla); }
    }

    // 🚨 MODEL: sekcja wordmarku ROSNIE z fw, logo wypelnia ja od dolu (patrz CSS).
    //   * --snkl-wm-max = pelna, naturalna wysokosc znaku przy jego realnej szerokosci
    //     renderu. Przy fw=1 kontener = maxWM = caly lockup. Dla lockupu 7.75:1 to
    //     ~154px na desktopie (content 1192) i ~47px na 390px mobile.
    //   * RANGE = ile trzeba przescrollowac, zeby dojsc do 1 = maxWM + wysokosc
    //     stopki prawnej pod wordmarkiem (to jest runway pod znakiem).
    //   * Licznik opiera sie o DOL rzedu platnosci, ktory jest NAD wordmarkiem, wiec
    //     NIE rusza sie gdy wordmark rosnie => zero sprzezenia zwrotnego. Przy dobiciu
    //     do samego dna p wychodzi DOKLADNIE 1 (punkt staly: gdy wordmark=maxWM,
    //     odslonieta ponizej platnosci czesc = maxWM+legal = RANGE => p=1).
    function mierz() {
      // Pelna wysokosc znaku = WYSOKOSC RENDERU obrazu, zmierzona wprost.
      // Dziala, bo CSS daje mu `width:100%; height:auto`, wiec jego wlasna wysokosc to
      // zawsze caly znak - kontener przycina go tylko WIZUALNIE (overflow), nie zmienia
      // layoutu <img>. Zweryfikowane: okno 118px przy obrazie 1217x157.
      var r = logo.getBoundingClientRect();
      var pelnaH = Math.round(r.height);
      if (!pelnaH) pelnaH = Math.round((r.width || clip.clientWidth || 0) * ASPECT_ZAPAS);
      maxWM = pelnaH;
      // 🚨 START = POLOWA logo widoczna (decyzja usera): min = 50% pelnej wysokosci,
      // wiec w spoczynku widac dolna polowe znaku, a scroll dosuwa gorna.
      var minWM = Math.round(maxWM * 0.5);
      // 🚨 ZMIENNE NA KORZENIU STOPKI, NIE NA SAMYM ZNAKU (poprawka 2026-08-06).
      // Zmienne CSS dziedzicza sie W DOL drzewa. Gdy siedzialy na `wm`, widzial
      // je wylacznie sam wordmark i jego dzieci - a stopka prawna i polityki sa
      // jego RODZENSTWEM, wiec dla nich `var(--snkl-wm-max, 96px)` spadalo na
      // wartosc zapasowa 96px zamiast realnych ~47px na mobile. Efekt: podciagane
      // byly o ~48px zamiast ~23px i wchodzily na znak (zgloszenie „tekst ze
      // stopki nachodzi na logo") - niezaleznie od tego, jak poprawialem selektor.
      // `f` jest wspolnym przodkiem znaku I tresci pod nim, wiec widza to samo.
      f.style.setProperty('--snkl-wm-max', maxWM + 'px');
      f.style.setProperty('--snkl-wm-min', minWM + 'px');
      // zostawione takze na `wm` - starsze reguly czytaja je z tego elementu
      wm.style.setProperty('--snkl-wm-max', maxWM + 'px');
      wm.style.setProperty('--snkl-wm-min', minWM + 'px');
      var legalH = legal ? legal.getBoundingClientRect().height : 0;
      range = Math.max(60, maxWM + legalH);
      lastW = window.innerWidth || doc.clientWidth;
      zmierzDoc();   // przy okazji odswiez cache wysokosci dokumentu (load/resize/img)
    }
    // ── NACIAG (overscroll) ────────────────────────────────────────────────────
    // Model docelowy (decyzja usera 2026-07-31): w spoczynku widac POLOWE logo,
    // mocniejsze przewijanie na dnie odslania reszte, a po puszczeniu WRACA do polowy.
    // Dlatego scroll odpowiada tylko za pierwsza polowe (0..0.5), a naciag za druga.
    // `pull` usuniete 2026-08-01 - stan trzymaja teraz `cel` (dokad) i `biezacy` (co widac).
    var pullT = 0, timer = null;

    function licz() {
      // przelicz maxWM/min gdy zmienila sie szerokosc (resize tool w podgladzie nie
      // zawsze odpala event 'resize' — pilnujemy tego tez tutaj, tanio)
      if ((window.innerWidth || doc.clientWidth) !== lastW) mierz();
      // 🚨 POMIAR MOGL WYJSC ZEROWY. mierz() startuje przy `load`, ale stopka bywa
      // wtedy jeszcze bez ukladu, a obraz ma `loading` odroczone - wtedy i rect obrazu,
      // i clientWidth klipu daja 0, wiec maxWM ladowal na 0. Pierwsze pociagniecie
      // dzialalo na ZEROWYM zakresie (nic sie nie ruszalo), a gdy obraz sie doladowal,
      // wysokosc przeskakiwala z zera na pelna. To bylo zglaszane jako „przy pierwszym
      // scrollu logo rozwija sie chunkami". Ponawiamy pomiar, dopoki nie wyjdzie sensowny.
      if (!maxWM || maxWM < 1) mierz();
      // 🚨 fw = SAM naciag. Polowa logo to stan SPOCZYNKU (--snkl-wm-min = 50% max),
      // wiec scroll nie ma juz nic do odslaniania - inaczej na dnie wychodzilo 75%
      // zamiast 50%. Odslanianie ponad polowe robi wylacznie ciagniecie, ktore samo
      // odpuszcza i wraca do polowy.
      // 🚨 NIE wolamy tu set() - to petla rAF jest jedynym pisarzem --snkl-fw.
      // Wczesniej licz() nadpisywal interpolacje wartoscia skokowa i wracaly schodki.
      // 🚨 AUDYT 2026-08-04: w spoczynku (cel=0, biezacy=0, petla stoi) ruszPetle()
      // per zdarzenie scroll togglowal atrybut + odpalal jalowa klatke rAF na kazdej
      // stronie. Gdy nie ma czego animowac - nie ruszamy petli.
      if (cel === 0 && biezacy === 0 && klatka === null) {
        // 🚨 FIX 2026-08-04b (zgloszenie usera: "na dnie widac CALE logo, chowa sie
        // dopiero po scrollu"): audytowy early-return wycial PIERWSZE przejscie
        // petli, a petla jest jedynym pisarzem --snkl-fw - fallback CSS `1`
        // zostawal wiec na ekranie do pierwszego naciagu. Jednorazowy zapis stanu
        // spoczynku (sentinel p=-1 gwarantuje, ze to dokladnie raz), potem znow
        // zero pracy per scroll.
        if (p < 0) set(0);
        return;
      }
      ruszPetle();
    }
    // 🚨 AUDYT 2026-08-04: doc.scrollHeight czytany per KAZDE wheel/touchmove wymuszal
    // synchroniczny layout przy brudnym drzewie (rownolegle pisza parallax hero i klasy
    // headera) - na mobile touchmove strzela z czestotliwoscia klatek, na CALEJ stronie,
    // nie tylko przy stopce. Teraz: cache wysokosci dokumentu odswiezany co >=400ms,
    // pelny (swiezy) pomiar dopiero gdy cache mowi "blisko dna" (<=400px). Daleko od
    // stopki koszt zdarzenia = arytmetyka na cache, zero odczytow layoutu.
    // (Swiadomie BEZ IntersectionObservera - patrz komentarz przy nasluchach:
    // w podgladzie bywa martwym punktem awarii.)
    var docH = 0, docHt = 0;
    function zmierzDoc() { docH = doc.scrollHeight; docHt = Date.now(); }
    function naDnie() {
      var vh = window.innerHeight || doc.clientHeight;
      var y = window.scrollY || window.pageYOffset || doc.scrollTop || 0;
      if (!docH || Date.now() - docHt > 400) zmierzDoc();
      if (docH - (y + vh) > 400) return false;
      zmierzDoc();
      return docH - (y + vh) <= 2;
    }
    // 🚨 Wiersz wordmarku ROSNIE W UKLADZIE, wiec spycha stopke prawna (© + polityki)
    // w dol. Strona jest juz przewinieta na samo dno, wiec ta stopka wychodzila poza
    // ekran przy mocniejszym pociagnieciu (zgloszone 2026-07-31).
    // Doklejamy widok z powrotem do dna po kazdym przyroscie wysokosci.
    // Efekt uboczny, POZYTYWNY: naDnie() znow jest prawda, wiec kolejne zdarzenia nie sa
    // odrzucane. Bez tego wzrost wysokosci sam sobie blokowal dalsze ciagniecie.
    // Przy POWROCIE nic nie trzeba robic - gdy strona sie skraca, przegladarka sama
    // przycina scrollY do nowego maksimum.
    /* ══════════════════════════════════════════════════════════════════════════
       🚨 ZAWOR ODDAJACY SCROLL (2026-08-06, kopia testowa).

       DIAGNOZA. Model „rosnaca wysokosc + przypinanie do dna" na DESKTOPIE jest
       swietny (potwierdzone przez usera) i to on daje wrazenie ROZCIAGANIA sie
       strony. Na dotyku ten sam model potrafil sie zaciac, bo przegladarka
       prowadzi wlasne przewijanie, a nasze scrollTo z nim walczylo.
       Roznica lezy wiec w SPOSOBIE WPROWADZANIA, nie w wygladzie - dlatego
       zamiast rezygnowac z rozciagania (proba z clip-path: user odrzucil,
       „logo samo sie odkrywa zza bialego bloku"), dokladamy zawor.

       ZASADA: w chwili, gdy uzytkownik ruszy W GORE, przypinanie ma NATYCHMIAST
       zamilknac i nie odzywac sie, dopoki nie pociagnie ponownie w dol z dna.
       Wczesniejsze podejscia zawezaly OKNA, w ktorych przypinanie dziala (tylko
       przy wzroscie, tylko przy palcu w gorze) - ale w kazdym z tych okien nadal
       moglo trafic na gest w gore. Tu decyduje INTENCJA uzytkownika, nie faza.

       `naszSkok` odsiewa zdarzenia scrolla, ktore sami wywolalismy - bez tego
       przypiecie natychmiast zablokowaloby samo siebie.
       ══════════════════════════════════════════════════════════════════════════ */
    var blokujPrzypinanie = false;
    var ostatniY = window.scrollY || window.pageYOffset || 0;
    var naszSkok = false;
    window.addEventListener('scroll', function () {
      var y = window.scrollY || window.pageYOffset || 0;
      if (naszSkok) { naszSkok = false; ostatniY = y; return; }
      if (y < ostatniY - 1) blokujPrzypinanie = true;   // ruch w gore = oddaj scroll
      ostatniY = y;
      // dopoki przewijanie zyje po palcu, przesuwamy koniec okna pedu
      if (pedDo !== 0) pedDo = Date.now() + 140;
    }, { passive: true });

    function przypnijDoDna() {
      if (blokujPrzypinanie) return;
      var vh = window.innerHeight || doc.clientHeight;
      // 🚨 nazwa `celScroll`, NIE `cel` - `cel` to CEL ANIMACJI wordmarku.
      // Lokalne `var cel` przeslanialo go i bylo pulapka przy kazdej pozniejszej edycji.
      var celScroll = doc.scrollHeight - vh;
      var y = window.scrollY || window.pageYOffset || 0;
      // 🚨 dopinaj tylko MIKRO-odstep (przyrost wysokosci z naciagu to pojedyncze
      // piksele na klatke). Duzy odstep = user INTENCJONALNIE odjechal w gore -
      // sciaganie go z powrotem byloby porwaniem scrolla (zgloszenie 2026-08-04c).
      if (celScroll > y && celScroll - y <= 200) {
        naszSkok = true;                 // nastepne zdarzenie scrolla jest NASZE
        window.scrollTo(0, celScroll);
      }
    }
    // Wysokosc dochodzi TRANZYCJA (0.1s), wiec w chwili zdarzenia scrollHeight jest
    // jeszcze w polowie drogi. Dopinamy ponownie, gdy tranzycja dobiegnie konca.
    wm.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'height' && wm.hasAttribute('data-snkl-pull')) przypnijDoDna();
    });
    function odpuszczaj() {
      if (timer) return;
      timer = setInterval(function () {
        if (Date.now() - pullT < 260) return;   // hold zanim zacznie wracac
        // 🚨 Zjezdzamy CELEM, nie tym co widac. Petla rAF sama plynnie doprowadzi
        // obraz do nowego celu, wiec powrot jest tak samo gladki jak odslanianie.
        cel *= 0.90;
        if (cel < 0.01) { cel = 0; clearInterval(timer); timer = null; }
        ruszPetle();
      }, 60);
    }
    // 🚨 OSOBNE tempo dla kolka/touchpada i dla palca. `wheel` sypie duzymi deltami
    // (touchpad potrafi dac 100+ na machniecie), a `touchmove` daje tyle, ile palec
    // realnie przejechal - przy wspolnym dzielniku na mobile trzeba bylo przeciagac
    // ekran kilka razy. Palec dostaje wiec ~2x czulszy przelicznik.
    // 🚨 TEMPO (decyzja usera 2026-07-31: „szybsze"): kolko 1100 -> 380 (pelne odsloniecie
    // z ~10 klikniec na ~3-4), palec 340 -> 190 (z 340 px przeciagniecia na 190 px).
    // Dodatkowo lockup z claimem jest ~2,2x nizszy niz stary wordmark, wiec ta sama
    // liczba klikniec dawala DUZO mniejszy ruch w pionie - stad dodatkowe przyspieszenie.
    // 🚨 JESZCZE LZEJ (2026-08-02: „efekt jest poprawny, ale trzeba mocno scrollowac"):
    // kolko 380 -> 250, palec 190 -> 130. Same dzielniki to jednak za malo - przy
    // deltach rzedu 100-120 i zdarzeniach co ~80 ms o kroku decydowal juz nie dzielnik,
    // tylko SUFIT CZASOWY nizej, wiec zmiana samych tych dwoch liczb byla praktycznie
    // niewidoczna. Dlatego razem z nimi podniesiony jest tez sufit.
    // 🚨 SUFIT NA JEDNO ZDARZENIE. Touchpad przy szybkim machnieciu potrafi wyslac
    // jeden `wheel` z deltaY rzedu 300-500 (a nie serie malych). Bez sufitu takie
    // zdarzenie dawalo skok o pol zakresu naraz - to wlasnie czytalo sie jako
    // „rozwija sie duzymi chunkami". Sufit rozbija je na kilka klatek, a przy
    // normalnym przewijaniu (delty 10-120) w ogole nie dziala, wiec nie spowalnia.
    var SUFIT_KROKU = 90;
    // 🚨 SUFIT CZASOWY - osobny od sufitu na zdarzenie, rozwiazuje INNY problem.
    // Bramka naDnie() przepuszcza ciagniecie dopiero na samym dnie strony. Gdy
    // uzytkownik dojezdza tam Z ROZPEDEM, zalegle zdarzenia pedu wpadaja SERIA
    // w kilkanascie milisekund i zjadaja caly zakres naraz - stad zgloszenie, ze
    // „przy PIERWSZYM scrollu logo rozwija sie chunkami". Przy pozniejszych,
    // swiadomych pociagnieciach zdarzenia sa rozlozone w czasie i problem nie wystepuje.
    // Ograniczamy PREDKOSC narastania: udzial zakresu na milisekunde.
    // 🚨 0.0028 -> 0.0045 (2026-08-02, razem z lzejszymi dzielnikami wyzej).
    // 0.0045/ms => pelne odsloniecie nie szybciej niz w ~220ms.
    // Przy serii pedu (dt ~16ms) daje to nadal tylko 0.072 na zdarzenie zamiast
    // 0.36, wiec HAMULEC NA „CHUNKI" ZOSTAJE - a to on byl powodem, dla ktorego ta
    // stala w ogole powstala. Luzujemy go o tyle, zeby przy swiadomym ciagnieciu
    // (dt ~80ms, limit 0.36) o kroku decydowal znow dzielnik, a nie sufit.
    var TEMPO_MAX = 0.0045;
    var tPoprz = 0;
    function ciagnij(d, dotyk) {
      if (d <= 0 || !naDnie()) return;
      /* 🚨 OTWARTY SELEKTOR KRAJU / JEZYKA = NACIAG WYLACZONY (2026-09-12, zgloszenie
         usera: „na desktopie, gdy okienko wyboru jezyka i waluty jest otwarte, scroll
         tego logo nie powinien dzialac w ogole, bo okienko scrolluje sie razem z logo").
         Mechanizm: lista krajow ma wlasny `overflow-y: auto` z `overscroll-behavior:
         contain`, wiec sama strona pod kolkiem NIE jedzie - ale zdarzenie `wheel`
         i tak bąbelkuje do `window`, a strona jest na dnie, wiec `naDnie()` przepuszcza
         je do naciagu: wordmark rosnie, dokument sie wydluza, `przypnijDoDna()` dosuwa
         widok - i rozwiniety selektor (pozycjonowany w rzedzie platnosci NAD znakiem)
         odjezdza razem z calym rzedem. Dla usera: „okienko ucieka spod kursora".
         Bramka po stanie, nie po celu zdarzenia: selektor ma byc nieruchomy takze przy
         kolku poza jego obszarem. Po zamknieciu (aria-expanded=false) naciag wraca. */
      if (f.querySelector('.snkl-footer__loc [aria-expanded="true"]')) return;
      // 🚨 Nowe ciagniecie W DOL Z DNA = uzytkownik znow chce rozciagac, wiec
      // zawor sie otwiera. Sam `d > 0` nie wystarcza - `naDnie()` gwarantuje,
      // ze naprawde wrocil na dol, a nie tylko machnal palcem w polowie strony.
      blokujPrzypinanie = false;
      var teraz = Date.now();
      var dt = tPoprz ? Math.min(teraz - tPoprz, 120) : 16;
      tPoprz = teraz;
      var krok = Math.min(d, SUFIT_KROKU) / (dotyk ? 130 : 250);
      krok = Math.min(krok, TEMPO_MAX * dt);
      cel = Math.min(1, cel + krok);        // 🚨 tylko CEL; rysuje petla rAF
      pullT = teraz;
      if (!maxWM || maxWM < 1) mierz();
      ruszPetle();
      // 🚨 to samo co w petli: przy aktywnym gescie zostawiamy przewijanie przegladarce
      if (!dotykAktywny && !pedTrwa()) przypnijDoDna();
      odpuszczaj();
    }
    // kolko, touchpad i palec generuja wheel albo touchmove - lapiemy oba
    window.addEventListener('wheel', function (e) { ciagnij(e.deltaY); }, { passive: true });
    var tY = null;
    window.addEventListener('touchstart', function (e) {
      tY = e.touches && e.touches[0] ? e.touches[0].clientY : null;
      dotykAktywny = tY !== null;
    }, { passive: true });
    window.addEventListener('touchmove', function (e) {
      if (tY == null || !e.touches || !e.touches[0]) return;
      var y = e.touches[0].clientY;
      ciagnij(tY - y, true);   // palec do gory = przewijanie w dol
      tY = y;
    }, { passive: true });
    // `touchcancel` tez, bo przy przelaczeniu aplikacji `touchend` nie przychodzi.
    function koniecDotyku() {
      tY = null;
      dotykAktywny = false;
      // 🚨 NIE dopinamy tutaj: w tej chwili ped dopiero rusza i `scrollTo` by go uciol.
      // Okno startowe 500 ms; kazde zdarzenie scrolla przedluza je o 140 ms (nizej).
      pedDo = Date.now() + 500;
      dopnijPoPedzie();
    }
    window.addEventListener('touchend', koniecDotyku, { passive: true });
    window.addEventListener('touchcancel', koniecDotyku, { passive: true });

    // Tani odczyt (dwa getBoundingClientRect, zero zapisow do layoutu przy scrollu),
    // wiec nasluch wisi bezwarunkowo - bez IntersectionObservera, ktory w podgladzie
    // bywa martwym punktem awarii. maxWM/legalH przeliczamy na resize i po load
    // (strona rosnie po doladowaniu zdjec i slidera podobnych par).
    window.addEventListener('scroll', licz, { passive: true });
    window.addEventListener('resize', function () { mierz(); licz(); }, { passive: true });
    window.addEventListener('load', function () { mierz(); licz(); });
    if (!logo.complete) logo.addEventListener('load', function () { mierz(); licz(); });
    mierz();
    licz();
  })();
